import {
  CalculateInsuranceProgramsRequest,
  InsuranceProgramDto,
} from 'shared/api/insurance'
import { differenceDate } from 'shared/lib/dateFormat'

import { InsuranceDraft, InsuranceProgram } from '../../../model/types'

type InsuranceCalculationDraft = Pick<
  InsuranceDraft,
  | 'country'
  | 'purpose'
  | 'startDate'
  | 'endDate'
  | 'travelerAges'
  | 'infantAges'
>

export const mapInsuranceDraftToCalculationRequest = (
  draft: InsuranceCalculationDraft,
): CalculateInsuranceProgramsRequest | null => {
  const { country, purpose, startDate, endDate, travelerAges, infantAges } =
    draft

  if (!country || !purpose || !startDate || !endDate) return null

  return {
    country_id: country.id,
    purpose_id: purpose.id,
    count_day:
      differenceDate({ dateStart: startDate, dateEnd: endDate, type: 'day' }) +
      1,
    adults: travelerAges.map((age) => ({ age_years: Number(age) })),
    children: infantAges.map((age) => ({ age_months: Number(age) })),
  }
}

export const mapInsuranceCalculationProgram = (
  program: InsuranceProgramDto,
): InsuranceProgram => ({
  id: program.id,
  name: program.program_name,
  title: program.title,
  subtitle: program.subtitle,
  description: program.description,
  isRecommended: program.is_recommended,
  coverage: program.summa_insurance,
  price: program.conv_premiya_insurance,
  currency: program.currency,
})
